import PropTypes from 'prop-types'
import { useCallback } from 'react'
import { Button, Label, kuiperClassNames } from '@opallabs/kuiper'
import { LabelPanel } from './LabelPanel'
import { LabelPickerLabel } from './LabelPickerLabel'
import { NoLabelsMessage } from './NoLabelsMessage'

import './styles.scss'

const LabelPicker = ({
  isPopover = false,
  labelSets = [],
  onClear,
  onSave,
  onSelect,
  onRemove,
  saveEnabled,
  setSaveEnabled,
  showSaveButton = false,
  shouldValidate = true,
  theme,
  valid,
}) => {
  const enableSaveButton = useCallback(
    (value) => {
      if (showSaveButton) {
        setSaveEnabled(value)
      }
    },
    [showSaveButton, setSaveEnabled]
  )

  return (
    <div className={kuiperClassNames('label-picker', theme)}>
      <div className={isPopover ? kuiperClassNames('label-container') : null}>
        <Label
          secondaryAction={!labelSets.length}
          shouldValidate={shouldValidate}
          text={
            <LabelPickerLabel
              hasLabels={Boolean(labelSets.length)}
              theme={theme}
            />
          }
          valid={valid}
        />
        {Boolean(labelSets.length) &&
          labelSets.map((labelSet) => (
            <LabelPanel
              key={labelSet.id}
              labelSet={labelSet}
              theme={theme}
              onClear={onClear}
              onRemove={onRemove}
              onSelect={onSelect}
              enableSaveButton={(value) => enableSaveButton(value)}
            />
          ))}
      </div>
      {!labelSets.length && <NoLabelsMessage theme={theme} />}
      {showSaveButton && (
        <Button disabled={!saveEnabled} label="Save" onClick={onSave} />
      )}
    </div>
  )
}
LabelPicker.displayName = 'Photon: LabelPicker'

LabelPicker.propTypes = {
  isPopover: PropTypes.bool,
  labelSets: PropTypes.array,
  onClear: PropTypes.func,
  onRemove: PropTypes.func,
  onSave: PropTypes.func,
  onSelect: PropTypes.func,
  saveEnabled: PropTypes.bool,
  setSaveEnabled: PropTypes.func,
  shouldValidate: PropTypes.bool,
  showSaveButton: PropTypes.bool,
  theme: PropTypes.oneOf(['light', 'dark']),
  valid: PropTypes.bool,
}

export default LabelPicker
